














import Vue from "vue";

export default Vue.extend({
  name: "DisplaySplitUnitCode",
  props: ["text", "row"],
  methods: {
    splitUnitCodes(value: string): string[] {
      if (!value) return [];
      return value.split(",").map(v => v.trim());
    },

    isSettled(code: string, settled: string | null): boolean {
      if (!settled) return false;

      const settledList = settled.split(",").map(v => v.trim());

      return settledList.includes(code);
    },
  },
});
